import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, StaticQuery } from 'gatsby';
import { enableAnimations } from 'config/helpers';
import LazyLoad from 'react-lazyload';
import {
  Banner,
  Contact,
  JoinUs,
  Offers,
  Video,
  Instagram,
  Carousel,
  CareerSlider,
} from './subcomponents';
import './Career.scss';

class Career extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    const { offers } = this.props;

    return (
      <StaticQuery
        query={graphql`
          query {
            contactImage: file(
              relativePath: { eq: "career/man-wearing-helmet.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 423) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            footerImage: file(
              relativePath: { eq: "career/man-rocket-chair.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            videoImage: file(relativePath: { eq: "culture/holacracy.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={data => (
          <div className={'single-page single-page--hero career'}>
            <Banner />
            <JoinUs />
            <Offers offers={offers} />
            <Contact
              background={data.contactImage.childImageSharp.fluid}
              title={'Haven’t found what you’re looking for?'}
              content={
                'No worries, drop us a line and tell us about your dream job: '
              }
              cta={'career@boldare.com'}
              link={'mailto:career@boldare.com'}
            />
            <LazyLoad once offset={200} >
              <Carousel />
            </LazyLoad>

            <Video image={data.contactImage.childImageSharp.fluid} />

            <LazyLoad once offset={200} >
              <CareerSlider />
            </LazyLoad>

            <Instagram />
            <Contact
              background={data.footerImage.childImageSharp.fluid}
              title={'Well, it’s you who makes all the difference at Boldare. '}
              content={'Come and join us! '}
              cta={'Jump to open positions'}
              link={'offers'}
              id={'career-footer'}
              scroll
            />
          </div>
        )}
      />
    );
  }
}

Career.propTypes = {
  offers: PropTypes.array.isRequired,
};

export default Career;
